import React from "react";

/**
 * A custom component that renders a shimmer effect.
 * @returns {JSX.Element} - The rendered shimmer component.
 */
const CustomeShimer = () => {
  return (
    <>
      <div className="Shimer"></div>
    </>
  );
};

export default CustomeShimer;
